// src/pages/Dashboard.js
import React, { useEffect, useState } from 'react';

function Dashboard() {
  const [trainings, setTrainings] = useState([]);
  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetch(`${API_BASE_URL}/trainings/trainings.php`, { credentials: 'include' })
      .then(response => response.json())
      .then(data => setTrainings(data))
      .catch(error => console.error('Error fetching trainings:', error));
  }, []);

  return (
    <div>
      <h1>Dashboard</h1>
      <ul>
        {trainings.map(training => (
          <li key={training.id}>{training.title}</li>
        ))}
      </ul>
    </div>
  );
}

export default Dashboard;
